import { fromJS, Map } from 'immutable';
import getIn from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';

import { GraphQL } from '../../graphql';
import { createReducer } from '../../lib/ReducerUtils';

// Curator sources are entities (ie. stations / playlists) that are generated from program curators.
// The keys will include station factory and playlist ids. Note that the key is NOT the curator id itself.
// The reason is due to fact that typically we will not have a curator id upfront to query its own metadata
// so we need to send an additional request using the curator source id instead.
const INITIAL_STATE = Map({});

export default createReducer(INITIAL_STATE, {
  [GraphQL.Constants.OperationNameActions.GRAPHQL_GET_STATION_CURATORS_SUCCESS]: saveCuratorSources,
  [GraphQL.Constants.OperationNameActions.GRAPHQL_GET_PLAYLIST_CURATORS_SUCCESS]:
    saveCuratorSources,
});

function saveCuratorSources(state: $TSFixMe, action: $TSFixMe): $TSFixMe {
  const annotations = getIn(action, ['response', 'entities', 'annotations'], {});
  const curatorSources = pickBy(annotations, annotation => {
    return !isEmpty(getIn(annotation, 'curator'));
  });

  return state.merge(fromJS(curatorSources));
}
